<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <b-row>
            <b-col cols="12">
                <FormInput type="text" label="Nombre del campo" name="name" id="name" rules="required" v-model="campo.name" />
            </b-col>
            <b-col cols="12" class="mb-4">
                <ValidationProvider :name="name" rules="required" mode="passive" v-slot="{ errors }">
                    <multiselect
                        v-model="campo.type"
                        :options="tipos"
                        placeholder="Seleccione el tipo de campo"
                        class="mt-3"
                        style="z-index: 999;"
                        @input="limpiarPrueba()"
                    ></multiselect>
                    <div v-if="errors.length > 0" style="background-color: #dc3545; color: #ffffff; font-size: 11px; padding: 5px 10px">{{ errors[0] }}</div>
                </ValidationProvider>
            </b-col>
            <b-col cols="12" v-if="esTipoSelect">
                <div class="d-flex align-items-center" v-for="(opcion, index) in campo.options" :key="index">
                    <b-col cols="5">
                        <FormInput type="text" label="Nombre de la opción" :name="'option-name-' + index" :id="'option-name-' + index" rules="required" v-model="opcion.name" />
                    </b-col>
                    <b-col cols="5">
                        <FormInput type="text" label="Nombre del valor" :name="'option-value-' + index" :id="'option-value-' + index" rules="required" v-model="opcion.value" />
                    </b-col>
                    <b-col cols="2" class="text-center">
                        <b-btn class="btn-add mr-2" @click.prevent="agregarOpcion(opcion)">
                            <span style="font-size: 25px;" class="mb-1">&#65291;</span>
                        </b-btn>
                        <b-btn class="btn-delete" @click.prevent="eliminarOpcion(index)" :disabled="campo.options.length == 2">&#x2715;</b-btn>
                    </b-col>
                </div>
            </b-col>
            <template v-if="campo.type === 'number' || campo.type === 'range'">
                <b-col cols="6">
                    <FormInput type="text" label="Valor mínimo" name="min_value" id="min_value" rules="" v-model="campo.min_value" />
                </b-col>
                <b-col cols="6">
                    <FormInput type="text" label="Valor máximo" name="max_value" id="max_value" rules="" v-model="campo.max_value" />
                </b-col>
            </template>
            <b-col cols="12">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" v-model="campo.required" id="required">
                    <label class="custom-control-label pt-1" for="required">El campo es obligatorio</label>
                </div>
            </b-col>
            <b-col cols="12" v-if="campo.type">
                <b-card class="mt-4">
                    <div v-html="infoCampo" class="mb-3"></div>
                    <h5>*Ya que actuará igual que en el formulario, en caso de ser obligatorio o no cumplir con las reglas dependiendo del tipo de campo, le mostrará los errores que también se mostrarían en el formulario. Simplemente rellene este campo de prueba como otro cualquiera para continuar. Este campo no se verá reflejado en ningún sitio.</h5>
                    <FieldComponent :field="campo" :desactivar="esTipoSelect ? !tieneOpcionesRellenadas : false" :value="pruebaSelect" v-model="pruebaSelect" class="mt-3" :style="esTipoSelect ? 'width: 96%' : ''"></FieldComponent>
                    <div class="mt-3">
                        <h6>
                            Una vez escriba en el campo o seleccione alguna opción, le aparecerá como se vería justo debajo:
                        </h6>
                    </div>
                    <h4 v-if="pruebaSelect">
                        {{ campo.name }}: {{ pruebaSelect}}
                    </h4>
                </b-card>
            </b-col>
            <div class="col-12 text-right mt-3">
                <Button type="submit" name="button" :class="esTipoSelect ? 'pr-3': ''" :disabled="esTipoSelect ? this.campo.options.length < 2 : false">
                    CONTINUAR
                    <InfoToolTip v-if="esTipoSelect" style="color: white !important;" :info="'Si selecciona tipo ' + campo.type + ' debe añadir mínimo dos opciones para poder crear el campo'" />
                </Button>
            </div>
        </b-row>
    </ValidationObserver>
</template>

<script>
import InfoToolTip from '@/components/common/InfoToolTip';
import FieldComponent from '@/components/common/FieldComponent';

export default {
    props: ['campo'],
    data() {
        return {
            tipos: ['text', 'email', 'select', 'multiselect', 'textarea', 'checkbox', 'radio', 'range', 'url', 'date', 'datetime-local', 'number'],
            pruebaSelect: null
        }
    },
    methods: {
        limpiarPrueba() {
            this.pruebaSelect = null;
            this.$emit('recargar');
        },
        async submit() {
            if (this.campo.type !== 'select' && this.campo.type !== 'multiselect') {
                delete this.campo.options;
            }

            const isValid = await this.$refs.observer.validate();
            if(isValid) {
                this.campo.teatro_id = this.teatro.id;

                this.terminar();
            }
        },
        agregarOpcion() {
            this.campo.options.push({
                name: '',
                value: ''
            });
        },
        eliminarOpcion(index) {
            if (this.campo.options.length > 2) {
                this.campo.options.splice(index, 1);
            }

            this.$emit('recargar');
        },
        terminar() {
            this.$emit('terminado');
        }
    },
    computed: {
        teatro() {
            return this.$store.getters.getTeatro;
        },
        infoCampo() {
            switch(this.campo.type) {
            case 'text' : return '<h4>Campo en el que solo se podrá poner texto, aquí tiene un ejemplo de como se vería en el formulario:</h4>';
            case 'email' : return '<h4>Campo en el que solo se podrá poner texto en formato email, aquí tiene un ejemplo de como se vería en el formulario:</h4>';
            case 'select' : return '<h4>Campo desplegable en el que podrá seleccionar <span class="underline">una</span> opción, aquí tiene un ejemplo de como se vería en el formulario:</h4>';
            case 'multiselect' : return '<h4>Campo desplegable en el que podrá seleccionar <span class="underline">múltiples</span> opciones, aquí tiene un ejemplo de como se vería en el formulario:</h4>';
            case 'textarea' : return '<h4>Campo de tipo área de texto, en el podrá escribir más texto que en un campo tipo texto normal y ponerle estilos al texto, aquí tiene un ejemplo de como se vería en el formulario:</h4>';
            case 'checkbox' : return '<h4>Campo de tipo check, en el podrá marcarlo o desmarcarlo, aquí tiene un ejemplo de como se vería en el formulario:</h4>';
            case 'radio' : return '<h4>Campo de tipo radio, en el podrá marcarlo, aquí tiene un ejemplo de como se vería en el formulario:</h4>';
            case 'range' : return '<h4>Campo de tipo rango, en el podrá seleccionar un valor numérico dentro de un rango específico, aquí tiene un ejemplo de como se vería en el formulario:</h4>';
            case 'url' : return '<h4>Campo de tipo url, aquí tiene un ejemplo de como se vería en el formulario:</h4>';
            case 'date' : return '<h4>Campo de tipo fecha, aquí tiene un ejemplo de como se vería en el formulario:</h4>';
            case 'datetime-local' : return '<h4>Campo de tipo fecha, aquí tiene un ejemplo de como se vería en el formulario:</h4>';
            case 'number' : return '<h4>Campo de tipo numerico, aquí tiene un ejemplo de como se vería en el formulario:</h4>';
            case 2 : return 'success'
            }

            return null;
        },
        tieneOpcionesRellenadas() {
            return this.campo.options && this.campo.options.length > 0 &&
                    this.campo.options[0].name !== '' && this.campo.options[0].value !== '' &&
                    this.campo.options[1].name !== '' && this.campo.options[1].value !== ''
        },
        name() {
            return this.campo.name ? this.campo.name : '';
        },
        esTipoSelect() {
            return this.campo.type === 'select' || this.campo.type === 'multiselect';
        }
    },
    components: {
        InfoToolTip, FieldComponent
    }
}
</script>

<style scoped>
    .btn-add {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.5rem;
        background-color: rgb(24 182 155);
        padding: 0.4rem;
        font-size: .875rem;
        line-height: 1.25rem;
        font-weight: 600;
        color: rgb(255 255 255);
    }
    .btn-delete {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.5rem;
        background-color: rgb(250 82 82);
        padding: 0.5rem 0.875rem;
        font-size: .875rem;
        line-height: 1.25rem;
        font-weight: 600;
        color: rgb(255 255 255);
    }
</style>
